/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stout_Weary_Swan_StabInputs */

const fr_stout_weary_swan_stab = /** @type {(inputs: Stout_Weary_Swan_StabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune catégorie trouvée`)
};

/**

* @param {Stout_Weary_Swan_StabInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const stout_weary_swan_stab = /** @type {((inputs?: Stout_Weary_Swan_StabInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stout_Weary_Swan_StabInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_stout_weary_swan_stab(inputs)
});